/*@ngInject*/
const GetUiFieldListRepository = function ($q, $timeout, baseRepository, formViewerConstant, baseCachedRepository) {

    angular.extend(this, baseRepository, baseCachedRepository);

    this.getCacheName = function () {
        return 'CachedUiFieldRepository';
    };

    this.getCacheCapacity = function () {
        return 50;
    };

    this.getUiFieldList = function (formTemplateType) {
        let url = '/rest/UIFormTemplate/fieldTypes',
            cacheKey = 'cachedUiFields-' + formTemplateType,
            config = {
                params: {
                    formTemplateType: formTemplateType
                }
            };

        return this.get(cacheKey, url, config);
    };

    this.getUiFormStructureList = function () {
        let defer = $q.defer(),
            sectionTpl = {
                label: 'Section Label',
                rows: [],
                repeatable: false
            },
            rowTpl = {
                fields: [],
                repeatable: false,
                rowRepeatable: false,
                staticLayout: false,
                repeaterField: null
            },
            rowRepeaterTpl = _.merge(_.clone(rowTpl), {
                repeatable: true,
                rowRepeatable: true
            }),
            result = {};

        result[ formViewerConstant.configuration.formStructureType.ROW ] = rowTpl;
        result[ formViewerConstant.configuration.formStructureType.ROW_REPEATER ] = rowRepeaterTpl;
        result[ formViewerConstant.configuration.formStructureType.SECTION ] = sectionTpl;

        $timeout(function () {
            defer.resolve(result);
        }, 200);

        return defer.promise;
    };

};

angular.module('umFormViewer')
    .service('getUiFieldListRepository', GetUiFieldListRepository);
